import React from "react";
import "./planpagelayout.css";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/";
import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { Button } from "antd/lib";
import {
  Compare_quote,
} from "../../Redux/actions/NumBikeation";
import { quick_quotes } from "../../Redux/actions/NumCaration";
import { QuickQuoteHealth } from "../../Redux/actions/NumHealth";
export default function HealthComparePlan({ compareQQ, setCompareQQ }) {
  const history = useHistory();
  console.log(compareQQ);
  const dispatch = useDispatch();
  const carQQuoteData = useSelector((state) => state?.healthdetail?.quickquotes);

  const onRemoveCompare = (index) => {
    const updatedQQuoteData = carQQuoteData?.map((quote, i) => {
      if (i === index) {
        return { ...quote, compare: !quote.compare };
      }
      return quote;
    });
    console.log(updatedQQuoteData);
    const trueObjects = updatedQQuoteData?.filter((quote) => quote.compare);
    console.log(trueObjects);
    setCompareQQ(trueObjects);
    dispatch(QuickQuoteHealth(updatedQQuoteData));
  };
  const ComparePlan = () => {
    history.push("/compareplan");
    dispatch(Compare_quote(compareQQ));
  };
  return (
    <>
      <div className="com-pln-sec">
        <div className="container d-flex justify-content-center align-items-center px-3 py-3">
          {/* {compareQQ?.map((quote, index) => (
            <div className="row comp-box">
              <div className="close-cmp-btn">
                <CloseOutlined onClick={() => onRemoveCompare(index)} />
              </div>
              <div key={index} className="col-lg-6 col-md-6 col-sm-6 col-6">
                <img className="qq-comp" src={quote?.logo} alt="" />
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                {quote?.provider === "icici" ? (
                  <p>ICICI LOMBARD</p>
                ) : quote?.provider === "goDigit" ? (
                  <p>GO DIGIT</p>
                ) : (
                  ""
                )}
              </div>
            </div>
          ))} */}
          {compareQQ?.slice(0, 3).map((quote, index) => (
            <div key={index} className="d-flex">
              {/* Map the 1st item in the compareQQ array */}
              <div className="plan-compare d-flex">
                {index === 0 && (
                  <div className="row comp-box">
                    <div className="close-cmp-btn">
                      <CloseOutlined onClick={() => onRemoveCompare(0)} />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                      <img className="qq-comp" src={quote?.logo} alt="" />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                      {quote?.insurer === "icici" ? (
                        <p>ICICI LOMBARD</p>
                      ) : quote?.insurer === "go_digit" ? (
                        <p>GO DIGIT</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
                {/* Map the 2nd item in the compareQQ array */}
                {index === 1 && compareQQ.length >= 2 && (
                  <div className="row comp-box">
                    <div className="close-cmp-btn">
                      <CloseOutlined onClick={() => onRemoveCompare(1)} />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                      <img className="qq-comp" src={quote?.logo} alt="" />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                      {quote?.insurer === "icici" ? (
                        <p>ICICI LOMBARD</p>
                      ) : quote?.insurer === "go_digit" ? (
                        <p>GO DIGIT</p>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
                {/* Map the 3rd item in the compareQQ array */}
                {index === 2 && compareQQ.length === 3 && (
                  <div className="row comp-box">
                    <div className="close-cmp-btn">
                      <CloseOutlined onClick={() => onRemoveCompare(index)} />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                      <img className="qq-comp" src={quote?.logo} alt="" />
                    </div>
                  </div>
                )}
              </div>
              {/* Show Add Plan 2 if index is not 1 and 2nd item is not added */}
              {index !== 1 && compareQQ.length < 2 && (
                <div className="row comp-box">
                  <span className="d-flex align-items-center justify-content-center gap-2" style={{color: "#b3a6a6"}}>
                    <PlusOutlined />
                    Add Plan 2
                  </span>
                </div>
              )}
              {index === 1 && compareQQ.length < 3 && (
                <div className="row comp-box">
                  <span className="d-flex align-items-center justify-content-center gap-2" style={{color: "#b3a6a6"}}>
                    <PlusOutlined />
                    Add Plan 3
                  </span>
                </div>
              )}
            </div>
          ))}
          <div>
            <Button
              type="primary"
              disabled={compareQQ?.length <= 1}
              onClick={ComparePlan}
            >
              Compare
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
